const expertInfoView = r => require.ensure([], () => r(require('@/page/expertInfo/expertInfo')), 'expertInfo');
const expertList = r => require.ensure([], () => r(require('@/page/expertInfo/expertList/expertList')), 'expertList');
const yaozhu = r => require.ensure([], () => r(require('@/page/expertInfo/yaozhu/yaozhu')), 'yaozhu');
const expertRecord = r => require.ensure([], () => r(require('@/page/expertInfo/expertRecord/expertRecord')), 'expertRecord');
const addExpert = r => require.ensure([], () => r(require('@/page/expertInfo/expertList/addExpert')), 'addExpert');
const EditExpert = r => require.ensure([], () => r(require('@/page/expertInfo/expertList/EditExpert')), 'EditExpert');
const addYaozhu = r => require.ensure([], () => r(require('@/page/expertInfo/addYaozhu/addYaozhu')), 'addYaozhu');
const yaozhuInfo = r => require.ensure([], () => r(require('@/page/expertInfo/yaozhuInfo/yaozhuInfo')), 'yaozhuInfo');

const expertInfoRouter = {
  path: '',
  name: '专家信息',
  component: expertInfoView,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
  },
  children: [{
      path: '/expertList',
      component: expertList,
      name: '专家管理',
      meta: {
        right: ['专家管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    }, {
      path: '/yaozhuInfo',
      component: yaozhuInfo,
      name: '摇珠详情',
      meta: {
        right: ['摇珠详情'],
        isShowMenu: true,
        keepAlive:true,
      },
    }, {
      path: '/addYaozhu',
      component: addYaozhu,
      name: '摇珠',
      meta: {
        right: ['摇珠'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/yaozhu',
      component: yaozhu,
      name: '摇珠管理',
      meta: {
        right: ['摇珠管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/expertRecord',
      component: expertRecord,
      name: '专家记录',
      meta: {
        right: ['专家记录'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/addExpert',
      component: addExpert,
      name: '添加专家',
      meta: {
        right: ['添加专家'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/EditExpert',
      component: EditExpert,
      name: '修改专家',
      meta: {
        right: ['修改专家'],
        isShowMenu: true,
        keepAlive:true,
      },
    }
  ]
};
export default expertInfoRouter;